import { render } from "./specialPrice.vue?vue&type=template&id=52f5384a&scoped=true"
import script from "./specialPrice.vue?vue&type=script&lang=js"
export * from "./specialPrice.vue?vue&type=script&lang=js"

import "./specialPrice.vue?vue&type=style&index=0&id=52f5384a&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f5384a"],['__file',"src/views/ticket/ticket/specialPrice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f5384a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f5384a', __exports__)) {
    console.log('reload')
    api.reload('52f5384a', __exports__)
  }
  
  module.hot.accept("./specialPrice.vue?vue&type=template&id=52f5384a&scoped=true", () => {
    console.log('re-render')
    api.rerender('52f5384a', render)
  })

}


export default __exports__